import application from 'application/application';

import moment from 'moment';

application.service('permissions', [
	'$http',
	'helper',
	'API',
	'$rootScope',
	'authentication',
	function($http, helper, API, $rootScope, authentication) {
		this.funcionalities = {
			// publications
			createDiary: -1, // Cadastrar diários
			createKeyword: -2, // Cadastrar palavras-chave
			createSearchVariation: -3, // Cadastrar variações de pesquisa
			createExclusionVariation: -4, // Cadastrar variações de exclusão
			combinedSearch: -5, // Cadastrar busca combinada
			downloadPublications: -6, // Gerar publicações em arquivo
			recordPublications: -7, // Consultar publicações

			// processes
			createProcess: -8, // Cadastrar processos
			createMovements: -9, // Consultar andamentos
			createManualMovements: -10, // Cadastrar andamentos manuais
			transformProcessIntoManual: -11, // Transformar processo automático em manual
			downloadMovements: -12, // Gerar andamentos em arquivo
			transformProcessIntoAutomatic: -16, // Transformar processo manual em automático
			processesWithAutomaticMovementsSearch: -32, // Processos com busca automática de andamentos
			searchAutomaticMovements: -31, // Pesquisar andamentos automáticos
			oabQuickRegister: -73, // Cadastro ágil da OAB

			// insurance
			createInsurance: -18, // Contratar seguro

			// schedule
			createSchedule: -21, // Criar agenda
			recordSchedule: -22, // Consultar agenda
			createAppointments: -23, // Cadastrar compromissos em agenda

			// finances
			financesLowsMaintenance: -50, // Manutenção de Baixas Financeiras
			financesLowsConsultation: -49, // Consultar Baixas Financeiras
			financesAccountJumps: -48, // Consultar Saldos de Contas Financeiras
			financesPostingsMaintenance: -47, // Manutenção de Lançamentos Financeiros
			financesPostingsConsultation: -46, // Consultar Lançamentos Financeiros
			financesAccountsMaintenance: -45, // Manutenção de Contas Financeiras
			financesAccountsConsultation: -44, // Consultar Contas Financeiras
			financesCategoriesMaintenance: -43, // Manutenção de Categorias
			financesCategoriesConsultation: -42, // Consultar Categorias
			financesMaintenance: -41, // Manutenção de Financeiros
			financesConsultation: -40, // Consultar Financeiros

			// contacts
			createContactList: -24, // Criar lista de contato
			createContactType: -25, // Criar tipos de contato
			createContact: -26, // Criar contatos
			recordContacts: -27, // Consultar contatos
			createContactActivity: -28, // Cadastrar atividades de contato
			recordContactActivity: -29, // Ver atividades de contatos

			// custummers
			createUsers: -30, // Cadastrar usuários

			// people
			contactListMaintenance: -29, // Manutenção de Lista de Contatos
			consultContactList: -28, // Consultar Lista de Contatos
			maintainingMarkers: -27, // Manutenção de Marcadores
			consultBookmarks: -26, // Consultar Marcadores
			contactMaintenance: -25, // Manutenção de Contatos
			consultContacts: -24, // Consultar Contatos

			//subpoena
			createSubpoena: -72,

			//debit
			freeDebit: -74, // Conslutar cálculos - GRATUITO
			debitPaid: -75, // (Consultar cálculos - PAGO)

			partsGenerator: -77 // Gerador de peças IA
		};

		this.loadPermissions = async () => {
			const permissionsPromise = await new Promise(resolve => {
				const refreshDate = new Date(sessionStorage.refreshPermissions);

				const storedFeatures = sessionStorage.userFeatures;

				const features =
					storedFeatures && storedFeatures !== 'undefined'
						? JSON.parse(storedFeatures)
						: false;

				if (features && refreshDate > new Date()) {
					resolve(true);
				} else {
					$http({
						...helper.http(API.permissions, 'GET'),
						params: {
							...helper.httpFields([
								'idFuncionalidade',
								'idUsuarioClienteXFuncionalidade'
							]),
							registrosPorPagina: -1,
							ativo: true
						},
						noCancelOnRouteChange: true
					}).then(({ data }) => {
						sessionStorage.userFeatures = JSON.stringify(data.itens);

						sessionStorage.refreshPermissions = moment().add(4, 'hours');

						resolve(true);
					});
				}
			});

			return await permissionsPromise;
		};

		this.get = feature => {
			const featureId = this.funcionalities[feature];

			const features = JSON.parse(sessionStorage.userFeatures);

			return (
				features.find(
					permission => permission.idFuncionalidade === featureId
				) || false
			);
		};

		this.has = feature => {
			const featureId = this.funcionalities[feature];

			$rootScope.haspermissions = sessionStorage.userFeatures ? true : false;

			if (sessionStorage.userFeatures != undefined) {
				const features = JSON.parse(sessionStorage.userFeatures);

				return features.some(
					permission => permission.idFuncionalidade === featureId
				);
			} else {
				return false;
			}
		};

		this.getProp = (name, prop) => {
			const feature = this.get(name);

			return feature[prop] || undefined;
		};

		this.userGroupAdm = async () => {
			const selectedGroup = localStorage.getItem('__groupSelected__') || false;

			if (selectedGroup === 'true') {
				const groupData = JSON.parse(localStorage.getItem('__groupUserData__'));

				$rootScope.hasGroupUserPermission = null;

				await $http({
					...helper.http(API.groupUsers, 'GET'),
					params: {
						...helper.httpFields(['*']),
						idsGrupoUsuarios: [groupData.idGrupo],
						idsSituacaoGrupoUsuario: [-1],
						paginaAtual: 1,
						registrosPorPagina: 10
					}
				})
					.then(response => {
						let groupUser = response.data.itens[0].listaUsuariosGrupo.filter(
							user =>
								user.idUsuarioCliente ==
								authentication.getUserData('idUsuarioCliente')
						);

						$rootScope.hasGroupUserPermission = groupUser[0]
							? groupUser[0].administrador
							: false;
					})
					.finally(() => {
						localStorage.setItem(
							'__hasGroupUserPermission__',
							$rootScope.hasGroupUserPermission
						);
						if (!$rootScope.hasGroupUserPermission) {
							$('#modalNotPermitted').modal('show');

							return false;
						}
					});
			} else {
				$rootScope.hasGroupUserPermission = true;
				localStorage.setItem(
					'__hasGroupUserPermission__',
					$rootScope.hasGroupUserPermission
				);
			}
		};
	}
]);
